import PlainPassword from './PlainPassword';

export default PlainPassword;
